import './style.scss';

const COOKIE_NAME = 'cpd_unlocked';

function getCookie(name) {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? match[2] : null;
}

function setCookie(name, value, days) {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${value}; expires=${expires}; path=/`;
}

export function presentations_cards_block() {
  const blocks = document.querySelectorAll('.presentations_cards_block');
  if (blocks.length === 0) return;

  blocks.forEach(block => {
    const cards = block.querySelectorAll('.presentation-card');
    const formModal = block.querySelector('.form-modal');
    const closeFormBtn = block.querySelector('.close-btn');

    if (!formModal) return;

    // ── Helpers ──────────────────────────────────────────────
    const openFormModal = (e) => {
      if (e) { e.preventDefault(); e.stopPropagation(); }
      formModal.classList.add('show');
      document.documentElement.classList.add('modal-opened');
    };

    const closeFormModal = () => {
      formModal.classList.remove('show');
      document.documentElement.classList.remove('modal-opened');
    };

    const closeSpecificVideoModal = (modal, mediaElement) => {
        modal.classList.remove('show');
        document.documentElement.classList.remove('modal-opened');

        if (mediaElement.tagName === 'VIDEO') {
            mediaElement.pause();
        } else if (mediaElement.tagName === 'IFRAME') {
            if (mediaElement.classList.contains('vimeo-iframe')) {
                mediaElement.contentWindow.postMessage('{"method":"pause"}', '*');
            } else if (mediaElement.classList.contains('youtube-iframe')) {
                mediaElement.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
            }
        }
    };

    // Initialize all video modals
    const activeModalsInfo = [];
    cards.forEach(card => {
        const modal = card.querySelector('.video-modal');
        if (modal) {
            const mediaElement = modal.querySelector('video, iframe');
            const closeBtn = modal.querySelector('.close-video-btn');

            if (mediaElement) {
                activeModalsInfo.push({ modal, mediaElement });

                const handleClose = (e) => {
                    if (e) {
                         e.preventDefault();
                         e.stopPropagation();
                    }
                    closeSpecificVideoModal(modal, mediaElement);
                };
                if (closeBtn) closeBtn.addEventListener('click', handleClose);
                modal.addEventListener('click', (e) => {
                    e.stopPropagation(); // Prevent bubbling up to the presentation-card
                    if (!e.target.closest('video') && !e.target.closest('iframe')) {
                        handleClose(e);
                    }
                });
                
                // Prevent right-click on the video modal to stop "Save video as..."
                modal.addEventListener('contextmenu', (e) => {
                    e.preventDefault();
                });
            }
        }
    });

    const closeAllVideoModals = () => {
        activeModalsInfo.forEach(({ modal, mediaElement }) => {
            if (modal.classList.contains('show')) {
                closeSpecificVideoModal(modal, mediaElement);
            }
        });
    };

    // ── Lock / unlock logic ───────────────────────────────────
    const isUnlocked = () => getCookie(COOKIE_NAME) === '1';

    const bindLockedCards = () => {
      cards.forEach(card => {
        card.removeEventListener('click', onCardClickLocked);
        card.removeEventListener('click', onCardClickUnlocked);
        card.addEventListener('click', onCardClickLocked);
      });
    };

    const bindUnlockedCards = () => {
      cards.forEach(card => {
        card.removeEventListener('click', onCardClickLocked);
        card.removeEventListener('click', onCardClickUnlocked);
        card.addEventListener('click', onCardClickUnlocked);
      });
    };

    function onCardClickLocked(e) {
      e.preventDefault();
      e.stopPropagation();
      openFormModal();
    }

    function onCardClickUnlocked(e) {
        e.preventDefault();
        e.stopPropagation();

        const card = this;
        const modal = card.querySelector('.video-modal');
        if (!modal) return;
        const mediaElement = modal.querySelector('video, iframe');
        if (!mediaElement) return;

        modal.classList.add('show');
        document.documentElement.classList.add('modal-opened');

        if (mediaElement.tagName === 'VIDEO') {
            mediaElement.play().catch(() => {});
        } else if (mediaElement.tagName === 'IFRAME') {
            if (mediaElement.classList.contains('vimeo-iframe')) {
                mediaElement.contentWindow.postMessage('{"method":"play"}', '*');
            } else if (mediaElement.classList.contains('youtube-iframe')) {
                mediaElement.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
            }
        }
    }

    const decryptMediaElements = () => {
      activeModalsInfo.forEach(({ mediaElement }) => {
        if (!mediaElement.getAttribute('src')) {
          const encSrc = mediaElement.getAttribute('data-enc-src');
          if (encSrc) {
            try {
              mediaElement.setAttribute('src', atob(encSrc));
            } catch (e) {}
          }
        }
      });
    };

    const unlock = () => {
      setCookie(COOKIE_NAME, '1', 365);
      block.classList.remove('locked');
      closeFormModal();
      bindUnlockedCards();
      decryptMediaElements();
    };

    // ── Initialise state ──────────────────────────────────────
    if (isUnlocked()) {
      block.classList.remove('locked');
      bindUnlockedCards();
      decryptMediaElements();
    } else {
      block.classList.add('locked');
      bindLockedCards();
    }

    // ── Form modal: close button & backdrop click ─────────────
    if (closeFormBtn) {
      closeFormBtn.addEventListener('click', closeFormModal);
    }
    formModal.addEventListener('click', (e) => {
      if (e.target === formModal) closeFormModal();
    });

    // ── Video modal: close button & backdrop click ────────────
    // Handled individually per modal above

    // ── ESC key ───────────────────────────────────────────────
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      if (formModal.classList.contains('show')) closeFormModal();
      closeAllVideoModals();
    });

    // ── Listen for HubSpot form submission ────────────────────
    window.addEventListener('message', (e) => {
      if (
        e.data &&
        e.data.type === 'hsFormCallback' &&
        e.data.eventName === 'onFormSubmitted'
      ) {
        unlock();
      }
    });
  });
}
